import { MapViewerConfiguration } from "../../config/map-viewer-configuration";
import { Constants } from "../../globals/constants";

export type KeyValuePair = {
    key: string | number;
    value: string;
};

export class KeyValueStore {
    projectCategories: KeyValuePair[];
    projectTypes: KeyValuePair[];
    projectStatuses: KeyValuePair[];
    compensationStatuses: KeyValuePair[];
    creationGoalSources: KeyValuePair[];
    usageCategories: KeyValuePair[];
    revisionTypes: KeyValuePair[];
    conditionControlStatuses: KeyValuePair[];
    conditionControlSources: KeyValuePair[];
    landfillSiteTypes: KeyValuePair[];
    eligibilityValues: KeyValuePair[];
    actionStatus: KeyValuePair[];
    mapViewerConfig: MapViewerConfiguration;

    constructor(mapViewerConfig: MapViewerConfiguration) {
        this.mapViewerConfig = mapViewerConfig;
        this.projectCategories = [
            {
                key: Constants.projectCategoryCreation,
                value: "Neuschaffung",
            },
            {
                key: Constants.projectCategoryUsage,
                value: "Beanspruchung",
            }
        ]
        this.projectTypes = [
            {
                key: Constants.projectTypeConstructionPermit,
                value: "Beanspruchung: Baubewilligung",
            },
            {
                key: Constants.projectTypeLandUsePlanChange,
                value: "Beanspruchung: Nutzungsplanänderung",
            },
            {
                key: Constants.projectTypeLandfillSite,
                value: "Beanspruchung: Abbau-/Deponieprojekt",
            },
            {
                key: Constants.projectTypeSoilImprovement,
                value: "Neuschaffung: Bodenverbesserung",
            },
            {
                key: Constants.projectTypeDezoning,
                value: "Neuschaffung: Auszonung",
            },
        ];
        this.projectStatuses = [
            {
                key: "in_bearbeitung",
                value: "in Bearbeitung",
            },
            {
                key: "vorwirkung",
                value: "Vorwirkung",
            },
            {
                key: "noch_nicht_in_Kraft",
                value: "beschlossen oder genehmigt, noch nicht in Kraft",
            },
            {
                key: "in_kraft",
                value: "in Kraft",
            },
            {
                key: "sistiert",
                value: "sistiert",
            },
            {
                key: "unbekannt",
                value: "unbekannt",
            },
        ];
        this.compensationStatuses = [
            {
                key: "in_bearbeitung",
                value: "in Bearbeitung",
            },
            {
                key: "zurueckgezogen",
                value: "zurückgezogen",
            },
            {
                key: "abgelehnt",
                value: "abgelehnt",
            },
            {
                key: "bewilligt",
                value: "bewilligt",
            },
            {
                key: "abgebrochen",
                value: "abgebrochen",
            },
            {
                key: "gemahnt",
                value: "gemahnt",
            },
            {
                key: "noch_nicht_abgenommen",
                value: "in Ausführung, Abnahme pendent",
            },
            {
                key: "abnahme_mit_maengel",
                value: "Abnahme mit Mängel",
            },
            {
                key: "abgeschlossen_mit_maengel",
                value: "abgeschlossen mit Mängel",
            },
            {
                key: "abgeschlossen",
                value: "abgeschlossen",
            },
            {
                key: "sistiert",
                value: "sistiert",
            },
        ];
        this.creationGoalSources = [
            {
                key: "rre",
                value: "RRE",
            },
            {
                key: "kommunaler_baubewilligungsentscheid",
                value: "Kommunaler Baubewilligungsentscheid",
            },
            {
                key: "bodenschutzkonzept",
                value: "Bodenschutzkonzept",
            },
            {
                key: "betriebsbewilligung",
                value: "Betriebsbewilligung",
            },
            {
                key: "nachsorgeverfuegung",
                value: "Nachsorgeverfügung",
            },
            {
                key: "andere",
                value: "andere",
            },
        ];
        this.usageCategories = [
            {
                key: "verkehr",
                value: "Verkehrsinfrastruktur (Kantons-, Gemeindestrasse, öffentlicher Verkehr)",
            },
            {
                key: "energie_versorgung_entsorgung",
                value: "Energie-, Ver- und Entsorgungsinfrastruktur",
            },
            {
                key: "infrastruktur_divers",
                value: "Infrastruktur divers (Parkplätze, Freizeitbauten, etc.)",
            },
            {
                key: "natur_und_hochwasserschutzbauten",
                value: "Natur-, Hochwasserschutzbauten",
            },
            {
                key: "landwirtschaftliche_oekonomiegebaeude",
                value: "Landwirtschaftliche Ökonomiegebäude (Ställe, Remisen, Silos, etc.)",
            },
            {
                key: "landwirtschaftliche_strukturverbesserung",
                value: "Landwirtschaftliche Strukturverbesserung (Güterstrasse, Bewässerung, etc.)",
            },
            {
                key: "weiterer_gewerbebetrieb",
                value: "Weiterer Gewerbebetrieb abZ (z.B. Holzindustrie, etc.)",
            },
            {
                key: "uebrige_nichtlandwirtschaftlich",
                value: "Übrige Nichtlandwirtschaftliche Bauvorhaben (Wohnbauten, Reitplätze, weitere)",
            },
            {
                key: "zuordnung_nicht_moeglich",
                value: "Zuordnung nicht möglich",
            },
        ];
        this.revisionTypes = [
            {
                key: "teilrevision",
                value: "Teilrevision"
            },
            {
                key: "gesamtrevision",
                value: "Gesamtrevision"
            }
        ]
        this.conditionControlStatuses = [
            {
                key: "erfuellt",
                value: "erfüllt"
            },
            {
                key: "pendent",
                value: "pendent"
            },
            {
                key: "nicht_relevant",
                value: "nicht relevant"
            },
            {
                key: "keine_auflage",
                value: "keine Auflage"
            }
        ]
        this.conditionControlSources = [
            {
                key: "regierungsratsentscheid",
                value: "Regierungsratsentscheid"
            },
            {
                key: "kommunaler_baubewilligungsentscheid",
                value: "Kommunaler Baubewilligungsentscheid"
            },
            {
                key: "betriebsbewilligung",
                value: "Betriebsbewilligung"
            },
            {
                key: "bodenschutzkonzept_bodenbericht",
                value: "Bodenschutzkonzept / Bodenbericht"
            },
            {
                key: "pflichtenheft",
                value: "Pflichtenheft"
            },
            {
                key: "merkblätter_richtlinien",
                value: "Merkblätter, Richtlinien, o.ä."
            },
            {
                key: "nicht_relevant",
                value: "nicht relevant"
            },
            {
                key: "andere",
                value: "andere"
            }
        ]
        this.landfillSiteTypes = [
            {
                key: "deponie_typ_a",
                value: "Deponie Typ A"
            },
            {
                key: "deponie_typ_b",
                value: "Deponie Typ B"
            },
            {
                key: "deponie_typ_c",
                value: "Deponie Typ C"
            },
            {
                key: "deponie_typ_d",
                value: "Deponie Typ D"
            },
            {
                key: "deponie_typ_e",
                value: "Deponie Typ E"
            },
            {
                key: "rohstoffabbaustellea",
                value: "Rohstoffabbaustelle"
            },
        ]
        this.eligibilityValues = [
            {
                key: 0,
                value: "keine FFF"
            },
            {
                key: 50,
                value: "50%"
            },
            {
                key: 99,
                value: "noch nicht anrechenbar"
            },
            {
                key: 100,
                value: "100%"
            },
        ]
        this.actionStatus = [
            {
                key: "actionRequired",
                value: "Handlungsbedarf"
            },
            {
                key: "noActionRequired",
                value: "kein Handlungsbedarf"
            },
            {
                key: "completed",
                value: "Projekt abgeschlossen"
            }
        ]
    }

    getProjectCategoryDisplayText(key: string) {
        const e = this.projectCategories.find((e) => e.key === key);
        return e?.value ?? "";
    }

    getFullProjectTypeDisplayText(key: string | undefined): string {
        const e = this.projectTypes.find((e) => e.key === key);
        return e != undefined ? e.value : "";
    }

    getProjectTypeDisplayText(key: string | undefined): string {
        const e = this.projectTypes.find((e) => e.key === key);
        return e != undefined ? e.value.split(": ")[1] : "";
    }

    getProjectStatusDisplayText(key: string | undefined): string {
        const e = this.projectStatuses.find((e) => e.key === key);
        return e?.value ?? "";
    }

    getCompensationStatusDisplayText(key: string | undefined): string {
        const e = this.compensationStatuses.find((e) => e.key === key);
        return e?.value ?? "";
    }

    getCreationGoalSourceDisplayText(key: string | undefined): string {
        const e = this.creationGoalSources.find((e) => e.key === key);
        return e?.value ?? "";
    }

    getUsageCategoryDisplayText(key: string | undefined): string {
        const e = this.usageCategories.find((e) => e.key === key);
        return e?.value ?? "";
    }

    getRevisionTypeDisplayText(key: string | undefined): string {
        const e = this.revisionTypes.find((e) => e.key === key);
        return e?.value ?? "";
    }

    getConditionControlStatusDisplayText(key: string | undefined): string {
        const e = this.conditionControlStatuses.find((e) => e.key === key);
        return e?.value ?? "";
    }

    getConditionControlSourceDisplayText(key: string | undefined): string {
        const e = this.conditionControlSources.find((e) => e.key === key);
        return e?.value ?? "";
    }

    getLandfillSiteTypeDisplayText(key: string | undefined): string {
        const e = this.landfillSiteTypes.find((e) => e.key === key);
        return e?.value ?? "";
    }

    getEligibilityValueDisplayText(key: number): string {
        const e = this.eligibilityValues.find((e) => e.key === key);
        return e?.value ?? "";
    }

    getActionStatusDisplayText(key: string): string {
        const e = this.actionStatus.find((e) => e.key === key);
        return e?.value ?? "";
    }
}
